import React, { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SceneCanvas } from '../SceneCanvas';
import { MobileHeader } from './MobileHeader';
import { MobileOverlay } from './MobileOverlay';
import { CandleProduct } from '../../types';

gsap.registerPlugin(ScrollTrigger);

interface MobileExperienceProps {
  scrollProgress: number;
  activeCandleIndex: number;
  setActiveCandleIndex: (idx: number) => void;
  onOpenCart: (candle?: CandleProduct) => void;
  onOpenFounderModal: () => void;
  onOpenCustomizerModal: () => void;
  onScrollToProgress: (target: number) => void;
  cartItemsCount: number;
  onTriggerShopTransition?: () => void;
  onOpenAccount?: () => void;
}

export const MobileExperience: React.FC<MobileExperienceProps> = React.memo(({
  scrollProgress,
  activeCandleIndex,
  setActiveCandleIndex,
  onOpenCart,
  onOpenFounderModal,
  onOpenCustomizerModal,
  onScrollToProgress,
  cartItemsCount,
  onTriggerShopTransition,
  onOpenAccount,
}) => {
  return (
    <div className="relative min-h-[10000px] bg-[#070504] selection:bg-amber-500/30 overflow-x-hidden">
      {/* Optimized Mobile 3D Canvas Scene */}
      <SceneCanvas
        scrollProgress={scrollProgress}
        activeCandleIndex={activeCandleIndex}
        onCandleSelect={setActiveCandleIndex}
        isMobile={true}
      />

      {/* Sticky Top Mobile Navigation Bar */}
      <MobileHeader
        cartCount={cartItemsCount}
        onOpenCart={onOpenCart}
        onScrollToTop={() => onScrollToProgress(0)}
        onTriggerShopTransition={onTriggerShopTransition}
        onOpenAccount={onOpenAccount}
      />

      {/* Full-Screen Mobile Story Scenes */}
      <MobileOverlay
        scrollProgress={scrollProgress}
        activeCandleIndex={activeCandleIndex}
        setActiveCandleIndex={setActiveCandleIndex}
        onOpenCart={onOpenCart}
        onOpenFounderModal={onOpenFounderModal}
        onOpenCustomizerModal={onOpenCustomizerModal}
        onScrollToProgress={onScrollToProgress}
        onTriggerShopTransition={onTriggerShopTransition}
      />
    </div>
  );
});


